import React, { Fragment, useEffect } from 'react';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import DefaultContain from 'Component/DashboardQeza/Category';

const Category = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Fragment>
            <Breadcrumbs parent="Kategori Perawatan" title="Daftar Kategori Perawatan" />
            <DefaultContain />
        </Fragment>
    );
};
export default Category;